import { ShopOutlined } from '@ant-design/icons';
import { fetchMyOrganizations } from 'api/organizations';
import DebounceSelect from 'components/Select/DebounceSelect';
import { AdminContext } from 'constants/contexts';
import React, { useContext } from 'react';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import {
  normalizeOrganizationOption,
  persistOrganizationSelection,
  repairPersistedOrganization,
} from 'utils/organization';
import { PartnerLogos } from './constants';
import { organizationSelector, organizationSelectorIcon, organizationSelectorIconContainer } from './styles';

function SelectOrganization({ collapsed, setCollapsed }) {
  const { organization, setOrganization } = useContext(AdminContext);
  const activeOrganization = repairPersistedOrganization(organization);

  const getOrganizations = (searchKey = '') => fetchMyOrganizations(searchKey).then((res) => {
    const data = getData(res)?.results?.map((o) => ({
      value: o.id,
      label: o.name,
      ...o,
    })) ?? [];

    const orgId = activeOrganization?.id;
    if (activeOrganization && orgId && !data.some((d) => d.value === orgId)) {
      data.push({
        value: orgId,
        label: activeOrganization.name || `Organization ${orgId}`,
        ...activeOrganization,
      });
    }

    return data;
  }).catch((e) => {
    captureException(e);
    return [];
  });

  const handleChangeOrganization = (_value, option) => {
    const organizationData = normalizeOrganizationOption(option);
    persistOrganizationSelection(organizationData);
    setOrganization(organizationData);
    window.location.reload();
  };

  const selectValue = activeOrganization?.id
    ? {
      value: activeOrganization.id,
      label: activeOrganization.name || `Organization ${activeOrganization.id}`,
    }
    : undefined;

  return (
    <div style={organizationSelector}>
      <span style={organizationSelectorIconContainer(collapsed)}>
        {PartnerLogos[activeOrganization?.id] ? (
          <img
            src={PartnerLogos[activeOrganization.id]}
            onClick={() => collapsed && setCollapsed(false)}
            alt="Logo"
            style={{
              height: 24,
              width: 24,
              objectFit: 'contain',
            }}
          />
        ) : (
          <ShopOutlined onClick={() => collapsed && setCollapsed(false)} style={organizationSelectorIcon} />
        )}

      </span>
      <DebounceSelect
        id="organizations"
        placeholder="Select an organization"
        fetchOptions={getOrganizations}
        onChange={handleChangeOrganization}
        value={selectValue}
        showSearch
        getPopupContainer={() => document.body}
        className={collapsed ? 'hidden' : 'w-full flex-1 organization-selector truncated-select'}
        variant="borderless"
      />
    </div>
  );
}
export default SelectOrganization;
